export const IS_TH = false;
export const IS_BK = true;
export const DOCUMENT_TITLE = 'documentTitle';
